import {GET_AUDITLOGS_FAILED, GET_AUDITLOGS_LOADING, GET_AUDITLOGS_SUCCESS } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    PAYLOAD: null,
  };
  
  export const getAuditReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_AUDITLOGS_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_AUDITLOGS_SUCCESS:
        return {
          ...state,
          loading: false,
          PAYLOAD: action.payload,
          error: null,
        };
      case GET_AUDITLOGS_FAILED:
        return {
          ...state,
          loading: false,
          PAYLOAD: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  